import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Steps, Typography } from "antd";
import { Wizard } from '@hdi-seguros/web-components.wizard';
import { WizardPreLiquidation } from "./Wizard";

import { ColSize, ErrorResults, RowSize } from "../../../shared/components";
import { PageHeader } from "../../../shared/components/MainLayout/components";
import { PreliquidationInitialStep } from "./shared/components/PreliquidationInitialStep";

import { GenericDataFormContext, GenericDataFormProvider } from "./shared/contexts/GenericDataForm";
import { InfoContext } from "../../../shared/contexts";

import { GenerateNewPreliquidationServiceResponse, LOADING_SAVED_PRELIQUIDATIONS_STATES } from "./shared/interfaces";

import { decrypt } from "../../../shared/utils";

import './index.css';

export const NewPreLiquidationContent = () => {
  const { 
    canShowConfirmIssue, 
    currentStep, 
    preliquidationInfo, 
    setPreliquidationInfo, 
    setLoadingSavedPreliquidation, 
    setCanShowSpinner,
    loadingSavedPreliquidation,
    loadPreliquidationState,
    setPreliquidationTotalValue
  } = useContext(GenericDataFormContext);

  const { setTitle } = useContext(InfoContext);

  const navigate = useNavigate();


  const stepsItems = useMemo(
    () => [
      { title: 'Principal' },
      { title: 'Cuotas' },
      { title: 'Confirmar' },
    ],
    []
  );

  const { id } = useParams();

  const [hasPreliquidationParam, setHasPreliquidationParam ] = useState<boolean>(id !== undefined);

  const validationExistPreliquidation = useCallback(async () =>{
    if(id) {
      setLoadingSavedPreliquidation(true);

      const parsedId = decrypt<{ preliquidationNumber: string, preliquidationTotalAmount: string }>(id);

      const preliquidationData: GenerateNewPreliquidationServiceResponse = {
        numeroPreliquidacion: parsedId.preliquidationNumber,
      };
      
      setPreliquidationTotalValue(parsedId.preliquidationTotalAmount)
      setPreliquidationInfo(preliquidationData);

      setCanShowSpinner(true);
  
      return;
    };

    setHasPreliquidationParam(false);
  }, [
    id, 
    setHasPreliquidationParam,
    setPreliquidationInfo,
    setLoadingSavedPreliquidation,
    setCanShowSpinner,
  ])

  useEffect(() => {
    setTitle('Preliquidación');
  }, []);
  
  useEffect(() => {
    validationExistPreliquidation();
  }, []);

  return (
    loadPreliquidationState === LOADING_SAVED_PRELIQUIDATIONS_STATES.HAS_ERROR
      ? <ErrorResults 
          title="Ha ocurrido un error en la carga de la preliquidación" 
          message={`Ha ocurrido un error tratando de recuperar la preliquidación número ${preliquidationInfo?.numeroPreliquidacion}`}
          actions={[{ label: 'Ir a las Preliquidaciones Guardadas', onClick: () => navigate('/cobranzas/preliquidaciones-guardadas') }]}
        />
      : (
        <>
          <PageHeader />
          <div className="preliquidation-container">
            {preliquidationInfo ? (
              !canShowConfirmIssue && (
                  <RowSize rowProps={{gutter:[0 , 0]}}>
                    <ColSize size={100}>
                      <Typography.Text strong className="fs-medium">
                        Preliquidación Nro.: {preliquidationInfo?.numeroPreliquidacion}
                      </Typography.Text>
                    </ColSize>
                  </RowSize>
              )
            ) : !hasPreliquidationParam && (
                <PreliquidationInitialStep />
            )}

            {preliquidationInfo && (
              <RowSize rowProps={{gutter:[0 , 0]}}>
                <ColSize size={100} colProps={{xs:{span: 4}, sm:{span: 4}}} className="pl-15">
                  {/*preliquidationInfo && !loadingSavedPreliquidation && (
                    {<Wizard currentStep={currentStep} stepsItems={stepsItems} />}
                  )*/}
                  <Steps current={currentStep} items={stepsItems}>

                  </Steps>
                </ColSize>
                <ColSize size={100} colProps={{xs:{span: 20}, sm:{span: 20}}} className="wizard-full-height">
                  <WizardPreLiquidation />
                </ColSize>
              </RowSize>
            )}
          </div>
        </>
      )
  )
}


export const NewPreLiquidationPage = () => {
  return (
      <GenericDataFormProvider>
        <NewPreLiquidationContent />
      </GenericDataFormProvider>
  )
}

